import React from "react";
import { SectionHeader } from "@/components/design-system/SectionHeader/SectionHeader";
import { BenefitCard } from "@/components/design-system/BenefitCard/BenefitCard";
import { benefits } from "./EmployerBenefitsSection.data";

export const EmployerBenefitsSection: React.FC = () => (
  <section id="for-hr-benefit-leaders" className="w-full overflow-hidden bg-neutral-100">
    <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
      <div className="mb-12 md:mb-16">
        <SectionHeader
          label="For HR & Benefit Leaders"
          heading={<>What your organization{" "}<span className="text-primary-500">gains.</span></>}
          description="Bravo is built to deliver measurable outcomes — not just engagement metrics."
        />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-3 xl:mx-auto xl:max-w-282">
        {benefits.map((benefit) => (
          <BenefitCard
            key={benefit.title}
            icon={<benefit.Icon className="h-16 w-16" />}
            title={benefit.title}
            description={benefit.description}
          />
        ))}
      </div>
    </div>
  </section>
);
